import { inject } from '@angular/core';
import { SCOPED_ACCESS_GATE } from '@mb/auth/client';
import type { PermissionAction, PermissionScope } from '@mb/auth/shared';
import { OrganizationContextStore } from '@modules/organization/client';

/**
 * Provides the app-wide organization context (available orgs + active org +
 * scoped permissions). Register after `provideWorkforceAuth()` — the store
 * hydrates off the AuthStore session lifecycle.
 */
export function provideOrganizationContext() {
  return [
    OrganizationContextStore,
    {
      provide: SCOPED_ACCESS_GATE,
      useFactory: () => {
        const store = inject(OrganizationContextStore);
        return {
          can: (entity: string, action: PermissionAction | string, minScope?: PermissionScope) =>
            store.can(entity, action as PermissionAction, minScope),
          selectedOrganizationId: () => store.selectedOrganizationId(),
        };
      },
    },
  ];
}
